import * as Accordion from '@radix-ui/react-accordion'
import { ChevronRight } from 'lucide-react'

export type FaqAccordionItem = {
  question: string
  answer: string
}

type FaqAccordionProps = {
  items: ReadonlyArray<FaqAccordionItem>
  variant?: 'home' | 'article'
}

export function FaqAccordion({
  items,
  variant = 'home',
}: FaqAccordionProps) {
  const rootClassName =
    variant === 'article' ? 'faq-list faq-list--article' : 'faq-list'

  return (
    <Accordion.Root type="single" collapsible className={rootClassName}>
      {items.map((item, index) => (
        <Accordion.Item
          key={item.question}
          value={`item-${index}`}
          className="faq-item"
        >
          <Accordion.Header className="faq-header">
            <Accordion.Trigger className="faq-trigger">
              <span>{item.question}</span>
              <ChevronRight
                className="faq-chevron"
                size={18}
                aria-hidden="true"
              />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="faq-content">
            <p>{item.answer}</p>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  )
}
